import React, { FunctionComponent } from 'react'
import { Trans } from 'next-i18next'
import { Heading, Text } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useAppRouter, useConsumerSelector } from '../../state'
import { BASE_PATH } from '../../env'
import Image from 'next/image'
import { Money } from '../Money'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { Money as MoneyType } from '@afterpay/types'

interface HeaderProps {
  creditLimit?: MoneyType
}

export const ApprovedCreditHeader: FunctionComponent<HeaderProps> = ({ creditLimit }) => {
  const { locale } = useAppRouter()
  const { profile } = useConsumerSelector()

  const consumerFirstName = profile?.givenNames ?? ''
  const headerSvgSrc = [BASE_PATH, 'images/approved-credit-illustration.svg'].join('/')
  return (
    <div className={styles.approvedCreditHeader}>
      <Heading size='XXL' bold={true}>
        <MaskedElement actionName='Approved Lending Header'>
          <Trans i18nKey={'consumerLending:approvedCredit:title'} values={{ consumerFirstName }} components={{ bold: <b /> }} />
        </MaskedElement>
      </Heading>
      <div className={styles.approvedCreditSubtitleWrapper}>
        <Text size='S'>
          <Trans i18nKey={'consumerLending:approvedCredit:subtitle'} />
          <b className={styles.approvedCreditSubtitle}>
            <Money value={creditLimit} color='White' locale={locale} size={'S'} />
          </b>
        </Text>
      </div>
      <div className={styles.approvedCreditIllustrationWrapper}>
        <Image
          data-testid='approved-credit-illustration'
          src={headerSvgSrc}
          alt=''
          width={176}
          height={170}
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        ></Image>
      </div>
    </div>
  )
}
